import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['option', 'radio', 'selectedRecipeName'];

  connect() {
    this.syncFromCheckedRadio();
  }

  selectOption(event) {
    // Clicking "View Details +" (or any modal trigger) inside a card should
    // open the modal without changing the selected recipe.
    if (event.target.closest('[data-bs-toggle="modal"]')) return;

    const option = event.target.closest(
      '[data-recipe-selector-target="option"]'
    );
    if (!option) return;

    const radio = option.querySelector('input[type="radio"]');
    if (!radio) return;

    if (radio.checked) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  selectRecipe(event) {
    const selectedRecipe = event.target.dataset.recipe;
    this.applySelection(selectedRecipe);
  }

  syncFromCheckedRadio() {
    const checkedRadio = this.radioTargets.find((radio) => radio.checked);
    if (!checkedRadio) return;

    this.applySelection(checkedRadio.dataset.recipe);
  }

  applySelection(selectedRecipe) {
    if (!selectedRecipe) return;

    this.updateHiddenFields(selectedRecipe);
    this.updateSelectedRecipeName(selectedRecipe);
    this.dispatchRecipeChanged(selectedRecipe);
  }

  updateHiddenFields(selectedRecipe) {
    this.optionTargets.forEach((option) => {
      const recipe = option.dataset.recipeSelectorRecipe;
      const skuSelect = option.querySelector(`#sku_select_${recipe}`);
      const quantityInput = option.querySelector(`#quantity_${recipe}`);
      const isSelected = recipe === selectedRecipe;

      if (skuSelect) {
        if (isSelected) {
          skuSelect.name = 'sku_id';
          skuSelect.disabled = false;
        } else {
          skuSelect.removeAttribute('name');
          skuSelect.disabled = true;
        }
      }

      if (quantityInput) {
        if (isSelected) {
          quantityInput.name = 'subscription[quantity]';
          quantityInput.disabled = false;
        } else {
          quantityInput.removeAttribute('name');
          quantityInput.disabled = true;
        }
      }
    });
  }

  updateSelectedRecipeName(selectedRecipe) {
    if (!this.hasSelectedRecipeNameTarget) return;

    const selectedRadio = this.radioTargets.find(
      (radio) => radio.dataset.recipe === selectedRecipe
    );

    const label = selectedRadio?.dataset.recipeLabel;
    if (!label) return;

    this.selectedRecipeNameTarget.textContent = label;
  }

  dispatchRecipeChanged(selectedRecipe) {
    window.dispatchEvent(
      new CustomEvent('recipe-selector:changed', {
        detail: { recipe: selectedRecipe },
      })
    );
  }
}
